import { memo } from "react";
import { Div, Icon, Text, useTheme, type DivProps, type OmitProps } from "react-better-html";

import { useI18n } from "../../utils/i18n";

import DecorationCard from "./DecorationCard";

type DecorationFamilyCardProps = OmitProps<DivProps, "children"> & {};

function DecorationFamilyCard({ ...props }: DecorationFamilyCardProps) {
   const theme = useTheme();
   const { t } = useI18n();

   return (
      <DecorationCard whiteSpace="nowrap" {...props}>
         <Div.row
            alignItems="center"
            gap={theme.styles.gap}
            marginBottom={theme.styles.gap}
            paddingRight={theme.styles.space * 2}
         >
            <Div.row
               width={38}
               height={38}
               alignItems="center"
               justifyContent="center"
               backgroundColor={theme.colors.success}
               borderRadius={theme.styles.borderRadius}
            >
               <Icon name="house" color={theme.colors.base} />
            </Div.row>

            <Text fontWeight={700}>{t((l) => l.components.decorations.family)}</Text>
         </Div.row>

         <Text fontSize={12} color={theme.colors.textSecondary}>
            4 {t((l) => l.common.properties)}
         </Text>
      </DecorationCard>
   );
}

export default memo(DecorationFamilyCard);
